import * as React from 'react';
import lang from '@practicegenius/register-account/src/lang';
import {styled} from '@mui/material/styles';
import Box from '@mui/material/Box';
import {Link} from '../../../components/Link';

const LoginTextWrapper = styled('p')(({theme}) => ({
  marginBottom: theme.spacing(2),
}));

export const loginBottomText = (
  <Box sx={{mb: 6}}>
    <LoginTextWrapper>
      {lang.common.loginBottomText.prompt}{' '}
      <Link href="/login" data-external>
        {lang.common.loginBottomText.linkText}
      </Link>
    </LoginTextWrapper>

    <LoginTextWrapper>
      {lang.common.linkMultipleAccounts.prompt}{' '}
      <Link
        href="https://support.patientrewardshub.com/hc/en-us/articles/4412255992717-Helping-Members-Create-Linked-Families"
        data-external
        target="_blank"
      >
        {lang.common.linkMultipleAccounts.linkText}
      </Link>
    </LoginTextWrapper>
  </Box>
);
